import React from 'react'
import { useTrans } from '@next-nx/hooks'
import { Close, Info } from '@next-nx/shared-ui/icons'
import { Tooltip } from '@next-nx/shared-ui/atoms'
import styles from './ProdottoServiziInclusi.module.sass'
import { MenuItemType } from '@next-nx/utils/types'
import { getIcon } from '@next-nx/utils/icons'

interface Props {
  item: MenuItemType
  className?: string
}

const ProdottoServiziInclusi = (props: Props) => {

  const { 
    item = undefined,
    className = '',
  } = props

  const t = useTrans()
  
  return item && item.children && item.children.edges.length > 0 ? (
    <div className={`${styles.root} ${className}`}>
      <p className={styles.title}>{item.name}</p>
      <div className={styles.list}>
        {item.children?.edges.map(x => (
          <div className={styles.item} key={x.node.pk}>
            <span className={styles.icon}>{getIcon(x.node.style)}</span>
            <div className={styles.content}>
              <span className={styles.label}>{x.node.name}</span>
              {!!x.node.description && (
                <>{' '}
                  <span className={styles.tooltip}>
                    <Tooltip 
                      id={`tooltip-servizio-incluso-${x.node.pk}`}
                      label={x.node.description}
                      pos="top"
                    >
                      <span className={styles.info}><Info /></span>
                    </Tooltip>  
                  </span>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  ) : <></>
}

export default ProdottoServiziInclusi
